import React from 'react';
import I18n from 'i18n-js';
import useFlags from '@/hooks/useFlags';

type UnitProjectScoreTypes = {
  hasBeenGraded: boolean,
  maxScore: number,
  score: number
};

const UnitProjectScore = ({ score, maxScore, hasBeenGraded }: UnitProjectScoreTypes) => {
  const { newUnitOverviewPage } = useFlags();
  const unitProjectLabel = I18n.t(newUnitOverviewPage
    ? 'total_unit_slideshows_score' : 'total_unit_projects_score');

  const scoreValue = () => {
    if (!hasBeenGraded) return 'Not graded';

    return score;
  };

  return (
    <div>
      <strong>{unitProjectLabel}:</strong> {' '}
      {scoreValue()} / {maxScore}
    </div>
  );
};

export default UnitProjectScore;
